var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6885 1.55434C6.8925 1.55434 7.0625 1.62234 7.1985 1.75834L17.0925 11.6523C17.2285 11.7883 17.2965 11.9583 17.2965 12.1623C17.2965 12.3663 17.2285 12.5363 17.0925 12.6723L7.1985 22.5663C7.0625 22.6797 6.90383 22.725 6.7225 22.7023C6.54117 22.7023 6.3825 22.6343 6.2465 22.4983C6.1105 22.385 6.0425 22.2377 6.0425 22.0563C6.01983 21.875 6.06517 21.7163 6.1785 21.5803L15.5965 12.1623L6.1785 2.74434C6.08784 2.63101 6.03117 2.50634 6.0085 2.37034C5.98584 2.23434 6.0085 2.09834 6.0765 1.96234C6.12184 1.84901 6.20117 1.747 6.3145 1.65634C6.42784 1.58834 6.5525 1.55434 6.6885 1.55434Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.043590b24cf225502dae2cab111600eb.svg";
export { ForwardRef as ReactComponent };